import { useState, useEffect, useCallback, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { adminGridTheme } from '../../theme/agGridTheme';
import { Search } from 'lucide-react';

ModuleRegistry.registerModules([AllCommunityModule]);

export default function AdminGrid({ columns, fetchData, onRowClick, pageSize = 20, quickFilter = true }) {
  const gridRef = useRef(null);
  const [rowData, setRowData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState('');

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchData();
      setRowData(data);
    } catch (err) {
      console.error('AdminGrid fetch error:', err);
      setRowData([]);
    }
    setLoading(false);
  }, [fetchData]);

  useEffect(() => { loadData(); }, [loadData]);

  const onGridReady = useCallback((params) => {
    params.api.autoSizeAllColumns();
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    params.api.autoSizeAllColumns();
  }, []);

  const handleRowClicked = useCallback((event) => {
    if (onRowClick) onRowClick(event.data);
  }, [onRowClick]);

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    suppressHeaderMenuButton: false,
    minWidth: 80,
  };

  return (
    <div className="flex flex-col" style={{ height: 'calc(100vh - 200px)' }}>
      {quickFilter && (
        <div className="mb-3">
          <div className="relative inline-block">
            <Search className="absolute left-2.5 top-2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search..."
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              className="text-sm bg-gray-800 border border-gray-700 text-gray-300 rounded-md pl-8 pr-3 py-1.5 w-64 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 placeholder-gray-500"
            />
          </div>
        </div>
      )}
      <div className="flex-1">
        <AgGridReact
          ref={gridRef}
          theme={adminGridTheme}
          rowData={rowData}
          columnDefs={columns}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={pageSize}
          paginationPageSizeSelector={[20, 50, 100]}
          quickFilterText={filterText}
          onGridReady={onGridReady}
          onFirstDataRendered={onFirstDataRendered}
          onRowClicked={onRowClick ? handleRowClicked : undefined}
          loading={loading}
          overlayNoRowsTemplate="<span class='text-gray-400 text-sm'>No data found</span>"
          rowClass={onRowClick ? 'cursor-pointer' : ''}
          suppressCellFocus={true}
        />
      </div>
    </div>
  );
}
